export default "__VITE_ASSET__b84aa346__"